class BlogFilter extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.addEventListener(
      'change',
      (event) => {
        const select = event.target.closest('.blog-filter__select');
        if (select && select.value) window.location.href = select.value;
      },
      { signal }
    );

    // bfcache restores the option the shopper picked before navigating away, not the one this page was rendered with.
    window.addEventListener('pageshow', () => this.restoreRenderedSelections(), { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  restoreRenderedSelections() {
    this.querySelectorAll('.blog-filter__select').forEach((select) => {
      const rendered = select.querySelector('option[selected]') || select.options[0];
      if (rendered) select.value = rendered.value;
    });
  }
}

if (!customElements.get('blog-filter')) customElements.define('blog-filter', BlogFilter);
